import type { ExportMetricsBodyFormat } from './exportMetricsBodyFormat';

export type ExportMetricsBody = {
  endDate: string;
  format: ExportMetricsBodyFormat;
  startDate: string;
  types?: string[];
};
